<template>
  <div class="jitsi-iframe " id="jitsi" >
    <loading-icon v-if="loading" expand />

    <div class="emergency-leave" v-if="afterLoadTimeout" @click="handleLeaveRoom">Leave Room</div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import axios from 'axios';
import LoadingIcon from '@/components/global/loading/LoadingIcon.vue';

export default {
  name: 'JitsiIframe',
  components: { LoadingIcon },
  props: {
    currentRoomData: Object,
  },
  data() {
    return {
      jaasToken: "",
      loading: true,
      muteAudio: false,
      muteVideo: false,
      loadTimeout: null,
      afterLoadTimeout: false,
      startedRecording: 0
    };
  },
  computed: {
    ...mapGetters({
      usersData: 'current_user/data',
      ifCurrentUserIsSpaceAdmin: 'current_user/isAreaAdmin',
      usersAvatar: 'current_user/avatar',
      isGuest: 'current_user/isGuest',
      isMobile: 'viewport/isMobile',
      isPremiumSpace: 'getCurrentAreaPremiumFeaturesEnabled',
      locationLifestyle: 'getCurrentUsersRoomLocationLifestyle'
    }),
    usersName() {
      let name = '';
      if (this.usersData) {
        name = `${this.usersData.firstName} ${this.usersData.lastName} ${this.usersData.pronouns ? `(${this.usersData.pronouns})` : ''}`;
      }
      return name;
    },
    usersEmail() {
      return this.usersData && this.usersData.email ? this.usersData.email : '';
    },
    id() {
      return this.currentRoomData?.id || ''
    },
    topic() {
      return this.currentRoomData?.name || ''
    },
    roomHost() {
      return this.currentRoomData?.hostEmail || ''
    },
    isFixedRoom() {
      return this.locationLifestyle === 'fixed' ? true : false
    }
  },
  watch: {
    currentRoomData(newVal, oldVal) {
      if(newVal.id !== oldVal.id) this.openJitsiIframe()
    },
  },
  methods: {
    ...mapActions(['handleLeaveRoom', 'popups/conferencing/jitsiRecordingStarted', 'popups/conferencing/jitsiError']),
    ...mapActions('routing', ['getQueryValue']),
    openJitsiIframe() {
      // let ifJitsiOpen = false;
      let jitsiIframe = document.querySelector('#jitsi iframe');
      if (jitsiIframe) {
        // ifJitsiOpen = true;
        jitsiIframe.remove()
      }
      let desktopOnlyButtons = [
        'desktop', //share screen (disabled on mob anyway)
        'videoquality', //performance settings
        'livestreaming',
        'mute-everyone',
        'mute-video-everyone',
        'sharedvideo',
        'shareaudio', //(disabled on mob anyway)
        'select-background',
        'stats', //speaker stats
        'settings'
      ]
      let toolbarButtons = [
        'microphone',
        'camera',
        'raisehand',
        'tileview',
        'fullscreen',
        'closedcaptions', // start/stop subtitles
        'hangup',
        'recording',
        'toggle-camera',
        'mute-everyone',
        'mute-video-everyone',
        ...desktopOnlyButtons
      ]
      let premiumOnlyButtons = [
        'livestreaming',
        'recording'
      ]
      if(!this.isPremiumSpace) { //filter out premium features if not a premium space
        toolbarButtons = toolbarButtons.filter((i) => !premiumOnlyButtons.includes(i))
      }
      if(this.isMobile) desktopOnlyButtons = []
      const options = {
        roomName: `vpaas-magic-cookie-605c24f7880c40ea9f86c029ef859dc8/${this.id}`,
        parentNode: document.querySelector('#jitsi'),
        jwt: this.jaasToken,
        configOverwrite: {
          remoteVideoMenu: {
            disableKick: true,
          },
          startWithAudioMuted: this.muteAudio,
          startWithVideoMuted: this.muteVideo,
          constraints: {
            video: {
              aspectRatio: 16 / 9,
              // height: {
              //   ideal: 720,
              //   max: 720,
              //   min: 240
              // }
            }
          },
          enableLayerSuspension: true,
          prejoinPageEnabled: false,
          disableThirdPartyRequests: false,
          buttonsWithNotifyClick: [{
            key: 'recording',
            preventExecution: false
          }],
        },
        interfaceConfigOverwrite: {
          ENABLE_FEEDBACK_ANIMATION: true,
          MAXIMUM_ZOOMING_COEFFICIENT: 1,
          APP_NAME: 'SPACEIN',
          DEFAULT_BACKGROUND: '#000000',
          DEFAULT_LOCAL_DISPLAY_NAME: 'me',
          DEFAULT_REMOTE_DISPLAY_NAME: 'Fellow participant',
          DISABLE_DOMINANT_SPEAKER_INDICATOR: true,
          DISABLE_FOCUS_INDICATOR: true,
          DISABLE_PRESENCE_STATUS: true,
          DISABLE_VIDEO_BACKGROUND: true,
          HIDE_INVITE_MORE_HEADER: true,
          LOCAL_THUMBNAIL_RATIO: 16 / 9,
          SHOW_CHROME_EXTENSION_BANNER: false,

          TOOLBAR_BUTTONS: toolbarButtons,
        }
      };
      const api = new window.JitsiMeetExternalAPI("8x8.vc", options);
      api.addListener('readyToClose', () => this.jitsiLeaveButtonHandler() );
      api.addListener('videoConferenceJoined', () => {
        this.loading = false
        api.executeCommand('subject', this.topic)
      })
      api.addListener('recordingStatusChanged', (event) => {
        //if current user started the recording (if clicked the recording button less than 2 mins ago)
        let currentUser = this.startedRecording && (Date.now() - this.startedRecording < 20000)
        if(event.on === true) this['popups/conferencing/jitsiRecordingStarted'](currentUser)
      })
      api.addListener('browserSupport', (event) => {
        if(!event.supported) this['popups/conferencing/jitsiError']('Your browser doesn\'t support up to date video conferencing. <br> Please update your browser to join the call.')
      })
      api.addListener('errorOccurred', (event) => {
        this['popups/conferencing/jitsiError'](event.message)
      })
      api.addListener('toolbarButtonClicked', (event) => {
        if(event.key === 'recording') {
          this.startedRecording = Date.now()
        }
      })
    },
    getJaaStoken(){
      var moderator = "false"
      //allow all space members to be jitsi moderator in fixed rooms
      if(this.isFixedRoom && !this.isGuest) moderator = "true"
      //make sure host can't be true if email (guest) is empty and roomHost is empty
      if((this.roomHost && this.usersEmail===this.roomHost) || this.ifCurrentUserIsSpaceAdmin){
        moderator = "true"
      }
      console.log("Are you moderator?", moderator)
      let jaasAuthDomain = process.env.VUE_APP_JAAS_AUTH_DOMAIN
      axios.post(jaasAuthDomain,
        {
          "id": this.usersEmail,
          "name": this.usersName,
          "email": this.usersEmail,
          "avatar": this.usersAvatar,
          "appid": "vpaas-magic-cookie-605c24f7880c40ea9f86c029ef859dc8",
          "kid": "vpaas-magic-cookie-605c24f7880c40ea9f86c029ef859dc8/9ba40b",
          "moderator": moderator
        })
      .then(response => {
        this.jaasToken = response.data

        this.openJitsiIframe();
      })
    },
    jitsiLeaveButtonHandler() {
      this.handleLeaveRoom()
    },
    async getConfigUrlParams() {
      let muteAudio = await this.getQueryValue('audio-muted')
      muteAudio === 'true' ? this.muteAudio = true : this.muteAudio = false
      let muteVideo = await this.getQueryValue('video-muted')
      muteVideo === 'true' ? this.muteVideo = true : this.muteVideo = false
    },
  },
  async mounted() {
    await this.getConfigUrlParams()
    this.getJaaStoken();
    this.loadTimeout = setTimeout(() => {
      this.afterLoadTimeout = true
    }, 3000)
    //allow for current users room to update and stuff when space switching
  },
  async beforeDestroy() {
    if(this.loadTimeout) clearTimeout(this.loadTimeout)
  }
};
</script>

<style lang="scss" scoped>
#jitsi {
  display: none;
  & > * {
      grid-column: 1/2;
      grid-row: 1/2;
  }
  & .end-call-button {
      width: 55px;
      height: 50px;
      align-self: flex-end;
      justify-self: center;
      position: absolute;
      margin-bottom: 16px;
      background: transparent;
      cursor: pointer;
      border-radius: 1000px;
      z-index: 10000;
  }
  .loading-icon {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0.8;
    z-index: 2;
  }
}

.status-bar.current-space-page #jitsi {
  display: grid;
  height: auto;
  width: 100%;
  background-color: black;
  height: 100%;
  width: 100%;
}

.emergency-leave {
  background: $red;
  border-radius: 1rem;
  padding: 0.5rem 1rem;
  z-index: 0;
  position: absolute;
  bottom: 2rem;
  right: 2rem;
  font-weight: bold;
  cursor: pointer;
}
</style>

<style lang="scss">
#jitsi.jitsi-iframe iframe {
  z-index: 1;
}
</style>
